import React, { useCallback } from "react";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import {
    Box,
    Container,
    Grid,
    MenuItem,
    TextField,
    Popper,
    Paper,
    IconButton,
    List,
    ListItemIcon,
    ListItemText,
    Typography,
    Divider,
    ListItemAvatar,
    Avatar,
    CircularProgress,
    ListItemButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import "simplebar-react/dist/simplebar.min.css";
import qs from "query-string";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import { useDebounce } from "use-debounce";
import Highlighter from "react-highlight-words";
import "./SearchBar.scss";
import CategoriesList from "../CategoriesList/CategoriesList";
const useStyles = {
    input: {
        borderBottom: 0,
        "& .MuiOutlinedInput-input:focus": {
            outline: "none",
            boxShadow: "none !important",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
        },
    },
    hl: {},
};

function addslashes(str) {
    return (str + "").replace(/[\\"']/g, "\\$&").replace(/\u0000/g, "\\0");
}

const menu = [
    {
        value: "views",
        label: "Most Popular",
    },
    {
        value: "most_recent",
        label: "Most Recent",
    },
    {
        value: "creator_name",
        label: "Creator Name",
    },
    {
        value: "with_video",
        label: "With Video",
    },
];
const queryTemplate = (term, sort, category) => {
    const loginId = TVSite?.loginId;
    let content = "";
    let creators = "";
    let tags = "";

    let contentFilters = "";
    let creatorFilters = "";
    let searchTagsFilters = "";
    let contentSort = "";
    let creatorSort = "";

    if (term?.trim() !== "") {
        contentFilters = `search:{ term: "${term}"}`;
        creatorFilters = `search:{ term: "${term}"}`;
        searchTagsFilters = `search: "${term}"`;
    }
    if (contentFilters) {
        content = `, filter: {${contentFilters}}`;
    }
    if (creatorFilters) {
        creators = `, filter: {${creatorFilters}}`;
    }
    if (searchTagsFilters) {
        tags = `, filter:{${searchTagsFilters}}`;
    }

    return `
        {
        content(client_id: ${loginId} ${content} ${contentSort}) {
            total
            items {
            content_id
            title
            content_type,
            creation_date
            }
        },
        creators(client_id: ${loginId} ${creators} ${creatorSort}){
            total,
            items{
            full_name,
            thumbnail,
            creator_id
            }
        },
        search_tags(client_id: ${loginId} ${tags}){
            total,
            items
        }
        }
`;
};

const initialState = {
    content: { items: [], total: 0 },
    creators: { items: [], total: 0 },
    search_tags: { items: [], total: 0 },
};
const SearchIcon = () => (
    <svg
        style={{ marginRight: "4px" }}
        width="21"
        height="19"
        viewBox="0 0 21 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Path">
            <path
                id="Path_2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.71003 0C4.01881 0 0.21582 3.51776 0.21582 7.85714C0.21582 12.1965 4.01881 15.7143 8.71003 15.7143C10.6642 15.7143 12.4643 15.1039 13.8995 14.0779L18.7644 18.6544L18.8655 18.7384C19.2868 19.0467 19.9003 19.0238 20.2933 18.6664C20.719 18.2791 20.7248 17.646 20.3062 17.2522L15.4293 12.6644C16.542 11.3357 17.2042 9.66795 17.2042 7.85714C17.2042 3.51776 13.4012 0 8.71003 0ZM8.71003 2C12.2071 2 15.0421 4.62233 15.0421 7.85714C15.0421 11.092 12.2071 13.7143 8.71003 13.7143C5.21294 13.7143 2.37798 11.092 2.37798 7.85714C2.37798 4.62233 5.21294 2 8.71003 2Z"
                fill="#323232"
            />
        </g>
    </svg>
);
const Bag = () => (
    <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Path">
            <path
                id="Path_2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9954 3.80036C11.8914 1.68397 10.1425 0 8.00028 0C5.79114 0 4.00028 1.79086 4.00028 4H3.78603C2.20486 4 0.895127 5.22721 0.79237 6.80503L0.141108 16.805L0.134766 17C0.134766 18.6569 1.47791 20 3.13477 20H12.8674C12.9317 20 12.996 19.9979 13.0601 19.9938C14.7135 19.8874 15.9676 18.4607 15.8612 16.8073L15.2175 6.80729C15.1159 5.22852 13.8057 4 12.2237 4H12.0003L11.9954 3.80036ZM10.0003 4C10.0003 2.89543 9.10485 2 8.00028 2C6.94591 2 6.08211 2.81588 6.00576 3.85074L6.00028 4H10.0003ZM10.0003 7V6H6.00028V7C6.00028 7.55228 5.55256 8 5.00028 8C4.48744 8 4.06477 7.61396 4.007 7.11662L4.00028 7V6H3.78603C3.25897 6 2.82239 6.40907 2.78814 6.93501L2.13688 16.935L2.13477 17C2.13477 17.5523 2.58248 18 3.13477 18L12.8995 17.9995L12.9316 17.9979C13.4828 17.9625 13.9008 17.4869 13.8653 16.9358L13.2216 6.93576C13.1878 6.40951 12.751 6 12.2237 6H12.0003V7C12.0003 7.55228 11.5526 8 11.0003 8C10.4874 8 10.0648 7.61396 10.007 7.11662L10.0003 7Z"
                fill="#323232"
            />
        </g>
    </svg>
);

const defaultSort = { children: "Most recent", value: "most_recent" };
const SearchBar = ({ updateSearchResults, resetRequestParameter }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortBy, setSortBy] = useState(defaultSort);
    const [results, setResults] = useState(initialState);
    const [isSearching, setIsSearching] = useState(false);
    const [debouncedTerm] = useDebounce(searchTerm, 1000);
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.up("sm"));

    const [initialized, setInitialized] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState(["All"]);

    useEffect(() => {
        search(debouncedTerm, sortBy.value, selectedFilters[0]);
    }, [debouncedTerm]);

    const goToSearchPage = (section = "", category = "", sort = "") => {
        if (category !== "All") {
            section += "&category=" + category;
        }
        if (sort) {
            section += "&sort=" + sort;
        }
        window.location.href =
            ConfigurationHelper.getGlobalConfiguration().sub_folder +
            `/search/?${section}`;
    };
    useEffect(() => {
        if (!initialized) {
            setInitialized(true);
            const params = qs.parse(window.location.search);
            if (window.location.pathname.includes("search")) {
                if (params?.query) {
                    setSearchTerm(params?.query);
                }
                if (params?.creatorName) {
                    setSearchTerm(params.creatorName);
                }
                if (params?.search_tag) {
                    setSearchTerm(params.search_tag);
                }
                if (params?.content) {
                    setSearchTerm(params.content);
                }
                if (params?.sortBy) {
                    const sort = menu.find((f) => f.value === params?.sortBy);
                    setSortBy({ children: sort?.label, value: sort?.value });
                }
                if (params?.category) {
                    setSelectedFilters([params?.category]);
                }
            }
        }
    }, [initialized]);

    const search = useCallback(
        (query, sortBy, category) => {
            setIsSearching(true);
            const phpEnvName = window?.TVSite?.phpEnvName;
            const env = phpEnvName === "local" ? "test" : phpEnvName;
            const apiUrl = `https://${env}.creatable.io/v3/api/search/graphql`;
            axios
                .post(
                    apiUrl,
                    {
                        query: queryTemplate(
                            addslashes(query),
                            sortBy,
                            category
                        ),
                    },
                    { withCredentials: true }
                )
                .then((response) => {
                    setResults(response.data.data);
                    setIsSearching(false);
                })
                .catch((error) => {
                    setIsSearching(false);
                });
        },
        [sortBy, selectedFilters]
    );

    const onKeyPress = (e) => {
        if (e.which === 13) {
            goToSearchPage(
                `query=${searchTerm}`,
                selectedFilters[0],
                sortBy.value
            );
        }
    };
    const onChange = (event) => {
        const { value } = event.target;
        if (value.trim() === "") {
            setAnchorEl(null);
        } else {
            setAnchorEl(event.currentTarget);
        }
        setSortBy(defaultSort);
        setSelectedFilters(["All"]);
        setSearchTerm(value);
        if (
            typeof resetRequestParameter === "function" &&
            (sortBy.value !== "most_recent" || !selectedFilters.includes("All"))
        ) {
            resetRequestParameter();
        }
    };
    const onSortChange = (e, value) => {
        setSortBy(value.props);
        if (typeof updateSearchResults === "function") {
            updateSearchResults({ sort: value.props.value });
        }
    };
    const onClickClear = () => {
        setAnchorEl(null);
        setSearchTerm("");
        setResults(initialState);
        if (window.location.pathname.includes("search")) {
            window.location.href =
                ConfigurationHelper.getGlobalConfiguration().sub_folder || "/";
        } else {
            if (typeof resetRequestParameter === "function") {
                resetRequestParameter();
            }
        }
    };

    const showClearButton = searchTerm?.trim() !== "";

    const onClickCategory = (category) => {
        setSelectedFilters([category]);
        if (typeof updateSearchResults === "function") {
            updateSearchResults({ category });
        }
    };
    return (
        <Box>
            <Container>
                <CategoriesList
                    onClickCategory={onClickCategory}
                    selectedFilters={selectedFilters}
                />
                <Box border={"1px solid #727272"} mb={2}>
                    <Grid container spacing={0}>
                        <Grid
                            item
                            xs={11}
                            md={9}
                            sx={{
                                position: "relative",
                                "&:after": {
                                    content: "''",
                                    width: "1px",
                                    display: "flex",
                                    height: "70%",
                                    top: "15%",
                                    right: 0,
                                    position: "absolute",
                                    backgroundColor: "#727272",
                                },
                            }}
                        >
                            <TextField
                                InputProps={{
                                    startAdornment: <SearchIcon />,
                                    endAdornment: showClearButton ? (
                                        <IconButton
                                            data-testId={"hub-search-clear"}
                                            disableRipple
                                            onClick={onClickClear}
                                            sx={{
                                                padding: 0,
                                                backgroundColor:
                                                    "rgba(0,0,0,0.04)",
                                            }}
                                        >
                                            <CloseIcon
                                                sx={{
                                                    height: "22px",
                                                    width: "22px",
                                                    marginRight: "0px",
                                                }}
                                            />
                                        </IconButton>
                                    ) : null,
                                }}
                                onKeyPress={onKeyPress}
                                data-testId={"search_input"}
                                onChange={onChange}
                                value={searchTerm}
                                size={"small"}
                                sx={{
                                    ...useStyles.input,
                                    "& input": { fontWeight: 600 },
                                }}
                                variant={"outlined"}
                                fullWidth
                                placeholder={"Search ambassador collections"}
                            />

                            <Popper
                                id={"search-bar-results"}
                                data-testId={"search-bar-results"}
                                modifiers={[
                                    {
                                        name: "flip",
                                        enabled: false,
                                        options: {
                                            altBoundary: true,
                                            rootBoundary: "document",
                                            padding: 8,
                                        },
                                    },
                                ]}
                                open={Boolean(anchorEl)}
                                sx={{ zIndex: 100, width: "100%" }}
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                            >
                                <Container>
                                    <Paper
                                        sx={{
                                            mt: 1,
                                            height: 400,
                                            maxHeight: 600,
                                            width: "100%",
                                            p: 2,
                                        }}
                                        elevation={2}
                                    >
                                        {isSearching ? (
                                            <Box
                                                position={"absolute"}
                                                sx={{
                                                    transform:
                                                        "translate(-50%, -50%)",
                                                    top: "50%",
                                                    left: "50%",
                                                }}
                                            >
                                                <CircularProgress />
                                            </Box>
                                        ) : (
                                            <Box
                                                display={"flex"}
                                                width={"100%"}
                                                maxHeight={"100%"}
                                                bgcolor={"#ffffff"}
                                                flexDirection={"column"}
                                                sx={{ overflowY: "auto" }}
                                            >
                                                <Box
                                                    position={"relative"}
                                                    width={"100%"}
                                                >
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={12}>
                                                            <Typography>
                                                                Keywords
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Box width={"100%"}>
                                                                <List
                                                                    data-testId={
                                                                        "keywords-list"
                                                                    }
                                                                >
                                                                    {results?.search_tags?.items?.map(
                                                                        (
                                                                            item
                                                                        ) => {
                                                                            return (
                                                                                <ListItemButton
                                                                                    onClick={() =>
                                                                                        goToSearchPage(
                                                                                            "search_tag=" +
                                                                                                item,
                                                                                            selectedFilters[0],
                                                                                            sortBy.value
                                                                                        )
                                                                                    }
                                                                                    key={
                                                                                        item
                                                                                    }
                                                                                    disablePadding
                                                                                >
                                                                                    <ListItemIcon
                                                                                        sx={{
                                                                                            minWidth:
                                                                                                "25px",
                                                                                        }}
                                                                                    >
                                                                                        <SearchIcon />
                                                                                    </ListItemIcon>
                                                                                    <ListItemText>
                                                                                        <Highlighter
                                                                                            searchWords={[
                                                                                                searchTerm,
                                                                                            ]}
                                                                                            highlightStyle={{
                                                                                                fontWeight: 500,
                                                                                                backgroundColor:
                                                                                                    "#ecfdef",
                                                                                                padding: 0,
                                                                                            }}
                                                                                            autoEscape={
                                                                                                true
                                                                                            }
                                                                                            textToHighlight={
                                                                                                item
                                                                                            }
                                                                                        />
                                                                                    </ListItemText>
                                                                                </ListItemButton>
                                                                            );
                                                                        }
                                                                    )}
                                                                </List>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                                <Box py={2}>
                                                    <Divider />
                                                </Box>
                                                <Box
                                                    position={"relative"}
                                                    width={"100%"}
                                                >
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={12}>
                                                            <Typography>
                                                                Ambassadors
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Box width={"100%"}>
                                                                <List
                                                                    data-testId={
                                                                        "ambassadors-list"
                                                                    }
                                                                >
                                                                    {results?.creators?.items?.map(
                                                                        (
                                                                            item,
                                                                            index
                                                                        ) => {
                                                                            return (
                                                                                <ListItemButton
                                                                                    onClick={() =>
                                                                                        goToSearchPage(
                                                                                            "creator_id=" +
                                                                                                item.creator_id +
                                                                                                "&creatorName=" +
                                                                                                item.full_name,
                                                                                            selectedFilters[0],
                                                                                            sortBy.value
                                                                                        )
                                                                                    }
                                                                                    key={
                                                                                        item.thumbnail +
                                                                                        index
                                                                                    }
                                                                                    disablePadding
                                                                                >
                                                                                    <ListItemAvatar
                                                                                        sx={{
                                                                                            minWidth:
                                                                                                "34px",
                                                                                        }}
                                                                                    >
                                                                                        <Avatar
                                                                                            src={
                                                                                                item.thumbnail
                                                                                            }
                                                                                            sx={{
                                                                                                width: 30,
                                                                                                height: 30,
                                                                                            }}
                                                                                        />
                                                                                    </ListItemAvatar>
                                                                                    <ListItemText>
                                                                                        <Highlighter
                                                                                            searchWords={[
                                                                                                searchTerm,
                                                                                            ]}
                                                                                            autoEscape={
                                                                                                true
                                                                                            }
                                                                                            highlightStyle={{
                                                                                                fontWeight: 500,
                                                                                                backgroundColor:
                                                                                                    "#ecfdef",
                                                                                                padding: 0,
                                                                                            }}
                                                                                            textToHighlight={
                                                                                                item.full_name
                                                                                            }
                                                                                        />
                                                                                    </ListItemText>
                                                                                </ListItemButton>
                                                                            );
                                                                        }
                                                                    )}
                                                                </List>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                                <Box py={2}>
                                                    <Divider />
                                                </Box>
                                                <Box
                                                    position={"relative"}
                                                    width={"100%"}
                                                >
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={12}>
                                                            <Typography>
                                                                Curated
                                                                Collections
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Box width={"100%"}>
                                                                <List
                                                                    data-testId={
                                                                        "curated-collections-list"
                                                                    }
                                                                >
                                                                    {results?.content?.items.map(
                                                                        (
                                                                            item
                                                                        ) => {
                                                                            return (
                                                                                <ListItemButton
                                                                                    onClick={() =>
                                                                                        goToSearchPage(
                                                                                            "content=" +
                                                                                                encodeURIComponent(
                                                                                                    item.title
                                                                                                ),
                                                                                            selectedFilters[0],
                                                                                            sortBy.value
                                                                                        )
                                                                                    }
                                                                                    key={
                                                                                        item.content_id
                                                                                    }
                                                                                    disablePadding
                                                                                >
                                                                                    <ListItemIcon
                                                                                        sx={{
                                                                                            minWidth:
                                                                                                "25px",
                                                                                        }}
                                                                                    >
                                                                                        <Bag />
                                                                                    </ListItemIcon>
                                                                                    <ListItemText>
                                                                                        <Highlighter
                                                                                            searchWords={[
                                                                                                searchTerm,
                                                                                            ]}
                                                                                            highlightStyle={{
                                                                                                fontWeight: 500,
                                                                                                backgroundColor:
                                                                                                    "#ecfdef",
                                                                                                padding: 0,
                                                                                            }}
                                                                                            autoEscape={
                                                                                                true
                                                                                            }
                                                                                            textToHighlight={
                                                                                                item.title
                                                                                            }
                                                                                        />
                                                                                    </ListItemText>
                                                                                </ListItemButton>
                                                                            );
                                                                        }
                                                                    )}
                                                                </List>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Box>
                                        )}
                                    </Paper>
                                </Container>
                            </Popper>
                        </Grid>
                        <Grid item xs={1} md={3}>
                            <TextField
                                onChange={onSortChange}
                                data-testId={"sort-list"}
                                id={"sort-list"}
                                value={sortBy.value}
                                SelectProps={{
                                    id: "sort-list-select",
                                    IconComponent: ExpandMoreIcon,
                                    autoWidth: false,
                                    renderValue: (value) =>
                                        isMobileView
                                            ? `Sort by: ${sortBy.children}`
                                            : "",
                                }}
                                size={"small"}
                                sx={useStyles.input}
                                variant={"outlined"}
                                select
                                fullWidth
                                placeholder={"Search ambassador collections"}
                            >
                                {menu.map((menuItem) => {
                                    return (
                                        <MenuItem
                                            key={menuItem.value}
                                            value={menuItem.value}
                                        >
                                            {menuItem.label}
                                        </MenuItem>
                                    );
                                })}
                            </TextField>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};
SearchBar.defaultProps = {
    placeholder: "Search Videos",
    arrow: false,
    updateSearchResults: () => {},
};

export default SearchBar;
